module.exports = __webpack_public_path__ + "img/ic_doc_upload.2ca706fd.svg";